import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { customInspectionTypeSettings } from '../../../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import en from '../../../../common/src/translate/en';
import nlOnly from '../../../../common/src/translate/nl';
import { getTranslate } from '../../../../common/src/translate/translateHelper';
import { mergeObjects } from '../../../../common/src/utils/mergeObjects';
import { appContext } from '../../components/appContext';
import { IConnectProps } from '../../utils/IConnectProps';
import { ITranslateProps } from '.';

const nl = { ...en, ...nlOnly };

const languages = { en, nl } as any;
const customInspectionTypesEn = Object.keys(customInspectionTypeSettings).map(
    (customInspectionType) => customInspectionTypeSettings[customInspectionType]?.translation.en ?? {},
);
const customInspectionTypesNl = Object.keys(customInspectionTypeSettings).map(
    (customInspectionType) => customInspectionTypeSettings[customInspectionType]?.translation.nl ?? {},
);

languages.en = mergeObjects(languages.en, ...customInspectionTypesEn);
languages.nl = mergeObjects(languages.nl, ...customInspectionTypesNl);

interface ITranslateReduxProps {
    languageCode: string;
}

function mapStateToProps(state: any) {
    const { language } = state;
    return {
        languageCode: language.code,
    };
}

export function useTranslate() {
    const currentAppContext = React.useContext(appContext.context);

    return useMemo(() => getTranslate(currentAppContext?.languageCode || 'en'), [currentAppContext?.languageCode]);
}

type PropsWithoutTranslateProps<P extends ITranslateProps> = Omit<P, keyof ITranslateProps>;

const translate =
    () =>
    <OriginalProps extends ITranslateProps>(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Component: React.ComponentClass<OriginalProps> | React.FC<OriginalProps>,
    ): React.ComponentClass<PropsWithoutTranslateProps<OriginalProps>> | React.FC<PropsWithoutTranslateProps<OriginalProps>> => {
        type ResultProps = OriginalProps; // & ExternalProps;
        const result = class Translate extends React.Component<ResultProps & ITranslateReduxProps & IConnectProps, Record<string, unknown>> {
            public override render() {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                const AnyComponent = Component;
                return (
                    <AnyComponent
                        {...this.props}
                        t={getTranslate(this.props.languageCode)}
                        // ref="wrappedInstance"
                    />
                );
            }

            // public getWrappedInstance(): any {
            //     return this.refs['wrappedInstance'];
            // }
        };

        return connect<ITranslateProps, ResultProps & IConnectProps, Record<string, unknown>>(mapStateToProps as any, undefined, undefined, {
            forwardRef: true,
        })(result as any) as any;
    };

export { translate };
